import React, { useEffect } from 'react';

import AssetService from '../../../../shared/services/AssetService';
import ColorPickerService from '../../../../shared/services/ColorPickerService';
import { ColumnAsset } from '../../../models/LessonComponentContent';
import { ColumnProps } from './Column';
import Grid from '@mui/material/Unstable_Grid2';
import LessonComponentService from '../../../services/LessonComponentService';
import styles from '../../../styles/Column.module.css';
import { useTheme } from '@mui/material/styles';

export default function ColumnView(props: ColumnProps) {
  const muiTheme = useTheme();
  const fontFamily = muiTheme.typography.fontFamily;
  const paragraphStyle = muiTheme.typography.custom1;

  const columns: ColumnAsset[] = props.component?.content?.column;
  const position = props.component?.settings.textPosition;

  useEffect(() => {
    // Adjusts all .square elements to be squares
    const handleResize = () => {
      const squares = document.querySelectorAll<HTMLElement>('.square'); // typed NodeList of HTMLElement

      squares.forEach((square) => {
        square.style.height = `${square.offsetWidth}px`;
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <div style={{ fontFamily }} className={styles.gridContainer}>
      {columns?.map((column, index) => (
        <div
          key={index}
          style={{
            width: '100%',
            alignItems: position,
            backgroundColor: column?.backgroundColor
              ? ColorPickerService.rgbToHex(column.backgroundColor)
              : undefined
          }}
          className={`square ${styles.columnContainer}`}
        >
          {column?.assetkey && (
            <img
              className={styles.image}
              src={AssetService.getAssetUrl(column.assetkey)}
            />
          )}
          {column?.text && (
            <Grid
              className={`${styles.textContainer} column-item-position ${position}`}
              style={{ ...paragraphStyle, padding: '30px' }}
            >
              <span
                style={{
                  overflow: 'auto',
                  height: '100%',
                  alignContent: `${position}`
                }}
                className={`ql-editor`}
                dangerouslySetInnerHTML={{
                  __html: LessonComponentService.getUrlWithSas(column?.text)
                }} //value has been sanitized before storing into db.
              ></span>
            </Grid>
          )}
        </div>
      ))}
    </div>
  );
}
